import * as React from 'react';
import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseFalseAnswer = ({ className }: IProps) => (
    <svg
        className={className}
        viewBox="0 0 78 78"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            fill="rgb(152, 50, 0)"
            d="M38.999,0.12 C60.546,0.12 78.12,17.453 78.12,39.0 C78.12,60.546 60.546,78.12 38.999,78.12 C17.453,78.12 0.12,60.546 0.12,39.0 C0.12,17.453 17.453,0.12 38.999,0.12 Z"
        />
        <path
            fillRule="evenodd"
            fill="rgb(255, 255, 255)"
            d="M25.64,17.701 L58.298,50.935 L51.935,57.298 L18.701,24.64 L25.64,17.701 Z"
        />
        <path
            fillRule="evenodd"
            fill="rgb(255, 255, 255)"
            d="M58.298,24.64 L25.64,57.298 L18.701,50.935 L51.935,17.701 L58.298,24.64 Z"
        />
    </svg>
);

export const FalseAnswer = styled(BaseFalseAnswer)``;
